const QUARTERS = 24 * 4;
export function parseQuietHoursTime(value) {
    const [h = "0", m = "0"] = value.split(":");
    const hours = Math.max(0, Math.min(23, Number.parseInt(h, 10) || 0));
    const minutes = Math.max(0, Math.min(59, Number.parseInt(m, 10) || 0));
    return hours * 4 + Math.round(minutes / 15);
}
export function formatQuietHoursTime(quarter) {
    const q = ((quarter % QUARTERS) + QUARTERS) % QUARTERS;
    const hour = Math.floor(q / 4);
    const minute = (q % 4) * 15;
    return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
}
export function formatQuietHoursFriendly(value) {
    const [h = "0", m = "0"] = value.split(":");
    const hours = Number.parseInt(h, 10);
    const minutes = Number.parseInt(m, 10);
    const meridiem = hours >= 12 ? "pm" : "am";
    const display = ((hours + 11) % 12) + 1;
    return minutes === 0
        ? `${display}${meridiem}`
        : `${display}:${String(minutes).padStart(2, "0")}${meridiem}`;
}
export function quietHoursDurationLabel(start, end) {
    let span = end - start;
    if (span <= 0)
        span += QUARTERS;
    const hours = Math.floor(span / 4);
    const minutes = (span % 4) * 15;
    if (hours === 0)
        return `${minutes}m`;
    if (minutes === 0)
        return `${hours}h`;
    return `${hours}h ${minutes}m`;
}
export const DEFAULT_QUIET_HOURS = { start: "22:00", end: "07:00" };
// Out-of-range ("25:99") is null, not "never quiet", so a bad window falls through.
export function quietHoursMinutes(hhmm) {
    const m = hhmm ? /^(\d{1,2}):(\d{2})$/.exec(hhmm) : null;
    if (!m)
        return null;
    const hh = Number.parseInt(m[1], 10);
    const mm = Number.parseInt(m[2], 10);
    return hh > 23 || mm > 59 ? null : hh * 60 + mm;
}
export function inQuietHours(window, minutesSinceMidnight) {
    const start = quietHoursMinutes(window.start);
    const end = quietHoursMinutes(window.end);
    if (start === null || end === null)
        return false;
    return start > end
        ? minutesSinceMidnight >= start || minutesSinceMidnight < end
        : minutesSinceMidnight >= start && minutesSinceMidnight < end;
}
//# sourceMappingURL=quiet-hours-time.js.map